import { Platform } from "react-native";
import { formatAmountToDecimal } from "../../utils"

export const receiptTemplate = (data, logo, playstore, appstore) => `
<!DOCTYPE html>
<html>
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
  <style>
  /* Replaced Google Fonts import with system font stack — saves ~200KB per render */
  html, body { min-width:260px; min-height:100%; padding:0; Margin:0 auto; background:#FFFFFF !important; }
  img, a{border:0px;}
  a img { border:0px; }
  a:link {color:#97291e;} 
  a:visited {color:#97291e;} 
  a:active { color: #FFFFFF; }
  .ReadMsgBody { width:100%; }
  .ExternalClass { width:100%; }
  .ExternalClass * { line-height:100%; }
  table, td { border-collapse:collapse; mso-table-lspace:0pt; mso-table-rspace:0pt; }
  a.maroon, a.maroon:link, a.maroon:visited, a.maroon:hover, a.maroon:focus, a.maroon:active{ color:#97291e !important; }
  a.whiteclr, a.whiteclr:link, a.whiteclr:visited, a.whiteclr:hover, a.whiteclr:focus, a.whiteclr:active{ color:#FFFFFF !important; }
  .showcent{display:none;}
  .receipt-table, .details-table { width:100%; border:1px solid #000; font-family:'Mulish',sans-serif; font-size:13px; }
  .receipt-table td, .details-table td { border:1px solid #000; padding:6px; vertical-align:top; }
  .receipt-table th, .details-table th { background:#f2f2f2; font-family:'Mulish',sans-serif; font-size:13px; padding:6px; border:1px solid #000; text-align:left; }
  .page-break-before { page-break-before: always; break-before: page; }
  /* Shared cell style — reduces repeated inline styles */
  .cell { font-family:'Mulish',sans-serif; font-size:14px; color:#000000; }
  .cell-bold { font-family:'Mulish',sans-serif; font-size:14px; color:#000000; font-weight:700; }
  .cell-base {
    padding:5px;
    background:#FFFFFF;
    border-right:1px solid #000;
    border-left:1px solid #000;
    border-bottom:1px solid #000;
  }
  .cell-top { border-top:1px solid #000; }
  </style>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <title></title>
</head>
<body>
  <table width="100%" border="0" cellpadding="0" cellspacing="0">
    <tr>
      <td></td>
      <td style="max-width:100%; width:600px;">
        <table width="100%" border="1" bordercolor="#E58220" cellspacing="0" cellpadding="0" style="border-collapse:collapse; border:1px solid #e58220;">
          <tr>
            <td>
              <table width="100%" border="0" cellpadding="0" cellspacing="0">
                <tr>
                  <td><img src=${logo} alt='Logo' /></td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td style="padding:0px 25px; font-family:'Mulish',sans-serif; font-size:14px; font-weight:700;">RECEIPT</td>
                </tr>
                <tr>
                  <td style="padding:0px 25px; font-family:'Mulish',sans-serif; font-size:14px;">&nbsp;</td>
                </tr>
                <tr>
                  <td style="padding:0px 25px; font-family:'Mulish',sans-serif; font-size:14px;">Tracking  Number: ${data.TrackNumber}</td>
                </tr>
                <tr><td style="padding:0px 25px;">&nbsp;</td></tr>
                <tr>
                  <td style="padding:0px 25px;">

                    <!-- Transaction / Today dates -->
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                      <tbody>
                        <tr>
                          <td width="25%" class="cell-base cell-top cell"><span>Transaction Initiation Date</span></td>
                          <td width="25%" class="cell-base cell-top cell"><span>${data.TxnInitiationDate}</span></td>
                          <td width="25%" class="cell-base cell-top cell"><span>Today's Date</span></td>
                          <td width="25%" class="cell-base cell-top cell"><span>${data.TodaysDate}</span></td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- Transfer / Available dates -->
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                      <tbody>
                        <tr>
                          <td width="25%" class="cell-base cell"><span>Transfer Date</span></td>
                          <td width="25%" class="cell-base cell"><span>${data.TransferDate}</span></td>
                          <td width="25%" class="cell-base cell"><span>Date Available<br>(may be available sooner)</span></td>
                          <td width="25%" class="cell-base cell"><span>${data.DateAvailable}</span></td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- Sender / Recipient headers -->
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                      <tbody>
                        <tr>
                          <td width="50%" class="cell-base cell-bold"><span>Sender</span></td>
                          <td width="50%" class="cell-base cell-bold"><span>Recipient</span></td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- Names -->
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                      <tbody>
                        <tr>
                          <td width="25%" class="cell-base cell"><span>Name</span></td>
                          <td width="25%" class="cell-base cell"><span>${data.Title} ${data.RemitterName}</span></td>
                          <td width="25%" class="cell-base cell"><span>Name</span></td>
                          <td width="25%" class="cell-base cell"><span>${data.ReceipientName}</span></td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- Addresses -->
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                      <tbody>
                        <tr>
                          <td width="25%" height="60" class="cell-base cell"><span>Address</span></td>
                          <td width="25%" class="cell-base cell" style="word-break:break-word;overflow-wrap:break-word;white-space:normal;max-width:0;">${data.Senderaddress}</td>
                          <td width="25%" class="cell-base cell"><span>Address</span></td>
                          <td width="25%" class="cell-base cell" style="word-break:break-word;overflow-wrap:break-word;white-space:normal;max-width:0;">${data.RecipientAddress}</td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- Phone numbers -->
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                      <tbody>
                        <tr>
                          <td width="25%" class="cell-base cell"><span>Phone Number</span></td>
                          <td width="25%" class="cell-base cell"><span>+${data.Senderphoneno}</span></td>
                          <td width="25%" class="cell-base cell"><span>Phone Number</span></td>
                          <td width="25%" class="cell-base cell"><span>+${data.ReceipientPhoneNumber}</span></td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- Sender bank -->
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                      <tbody>
                        <tr>
                          <td width="25%" class="cell-base cell"><span>Name of the Bank</span></td>
                          <td width="25%" class="cell-base cell"><span>${data.Rembankname}</span></td>
                          <td width="25%" class="cell-base cell">&nbsp;</td>
                          <td width="25%" class="cell-base cell">&nbsp;</td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- Amounts -->
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                      <tbody>
                        <tr>
                          <td width="50%" class="cell-base cell"><span>Transfer Amount (A)</span></td>
                          <td width="50%" class="cell-base cell"><span>USD ${formatAmountToDecimal(data.TransferAmount)}</span></td>
                        </tr>
                      </tbody>
                    </table>
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                      <tbody>
                        <tr>
                          <td width="50%" class="cell-base cell"><span>Transfer Fees (B)</span></td>
                          <td width="50%" class="cell-base cell"><span>USD ${formatAmountToDecimal(data.TransferFee)}</span></td>
                        </tr>
                      </tbody>
                    </table>
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                      <tbody>
                        <tr>
                          <td width="50%" class="cell-base cell"><span>Total (A+B)</span></td>
                          <td width="50%" class="cell-base cell"><span>USD ${formatAmountToDecimal(data.TOTAL)}</span></td>
                        </tr>
                      </tbody>
                    </table>
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                      <tbody>
                        <tr>
                          <td width="50%" class="cell-base cell"><span>Exchange Rate</span></td>
                          <td width="50%" class="cell-base cell"><span>USD 1 = INR ${formatAmountToDecimal(data.ExchangeRate)}</span></td>
                        </tr>
                      </tbody>
                    </table>
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                      <tbody>
                        <tr>
                          <td width="50%" class="cell-base cell"><span>Total to Recipient</span></td>
                          <td width="50%" class="cell-base cell"><span>INR ${formatAmountToDecimal(data.TotalToRecipient)}</span></td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- Disclaimer bullets -->
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                      <tbody>
                        <tr>
                          <td width="100%" class="cell-base cell" style="padding:5px 0;">
                            <ul type="disc">
                              <li>The recipient may receive a lesser amount&nbsp;due to fees charged by his/her bank and foreign taxes.</li>
                              <li>You have a right to dispute inaccuracies in your transaction. If you think there is any inaccuracy, contact us within 180 days on our toll-free number +1 (866) 424-2448 or write to us at <a href="mailto:nri@icici.bank.in">nri@icici.bank.in</a>. You can also contact us for a written explanation of your rights.</li>
                              <li>You can cancel the transaction and receive&nbsp;a full refund within 30 minutes of payment, unless the funds have been moved or deposited.</li>
                              <li>For questions or complaints related to ICICI Bank New York Branch:</li>
                              <li>Reach out to the Consumer Financial Protection Bureau:<br>
                              Tel: 855-411-2372, 855-729-2372 (TTY/TDD)<br>
                              <a href="https://www.consumerfinance.gov">www.consumerfinance.gov</a><br>
                              <span style="font-size:14px; margin-top:10px;"><br>
                              ICICI Bank Limited, New York Branch,<br>
575 Fifth Ave, Suite 2600,<br>
New York, NY 10017 USA<br>
Phone: (646) 827-8450<br>
Email: <a href="mailto:nri@icici.bank.in">nri@icici.bank.in</a><br>
Website: <a href="https://money2india.icici.bank.in/">https://money2india.icici.bank.in</a></span></li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>

                <!-- PAGE 2 -->
                <tr>
                  <td style="padding:0px 25px;">
                    <div style="display:block; ${Platform.OS === 'web' ? 'page-break-before:always; break-before:page; margin-top:220px;' : 'padding-top:50px;'}">

                      <!-- Additional details header -->
                      <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                        <tbody>
                          <tr>
                            <td width="100%" class="cell-base cell-top cell" style="padding:5px;">
                              <p style="font-family:'Mulish',sans-serif; font-weight:700;">Additional details of your transfer</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <!-- Purpose / Transfer Type -->
                      <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                        <tbody>
                          <tr>
                            <td width="25%" class="cell-base cell"><span>Purpose of<br>Payment</span></td>
                            <td width="25%" class="cell-base cell"><span>${data.PurposeofPayment}</span></td>
                            <td width="25%" class="cell-base cell"><span>Transfer Type</span></td>
                            <td width="25%" class="cell-base cell"><span>${data.TransferType}</span></td>
                          </tr>
                        </tbody>
                      </table>

                      <!-- Payment Mode / Recipient Bank -->
                      <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                        <tbody>
                          <tr>
                            <td width="25%" class="cell-base cell"><span>Payment Mode</span></td>
                            <td width="25%" class="cell-base cell"><span>${data.TrackNumber?.startsWith('M2D')? data.PaymentMode?.replace(/(\d+)$/, (match) => match.padStart(6, 'X')) : data.PaymentMode}</span></td>
                            <td width="25%" class="cell-base cell"><span>Recipient's Bank Name</span></td>
                            <td width="25%" class="cell-base cell"><span>${data.RecipientBankName}</span></td>
                          </tr>
                        </tbody>
                      </table>

                      <!-- Auth Code / Account Number -->
                      <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                        <tbody>
                          <tr>
                            <td width="25%" class="cell-base cell"><span>Authorisation<br>Code (if any)</span></td>
                            <td width="25%" class="cell-base cell"><span>${data.AuthorisationCode || 'NA'}</span></td>
                            <td width="25%" class="cell-base cell"><span>Recipient's Bank Account Number</span></td>
                            <td width="25%" class="cell-base cell"><span>${data.ReceipientBankAccount}</span></td>
                          </tr>
                        </tbody>
                      </table>

                      <!-- Exchange rates -->
                      <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                        <tbody>
                          <tr>
                            <td width="25%" class="cell-base cell"><span>Exchange Rate (without Promo Code)</span></td>
                            <td width="25%" class="cell-base cell"><span>USD 1 = INR ${formatAmountToDecimal(data.ExchangeRateWithoutPromoCode)}</span></td>
                            <td width="25%" class="cell-base cell"><span>Exchange Rate (includes Promo Code, if applicable)</span></td>
                            <td width="25%" class="cell-base cell"><span>USD 1 = INR ${formatAmountToDecimal(data.ExchangeRateIncludesPromoCodeIfApplicable)}</span></td>
                          </tr>
                        </tbody>
                      </table>

                      <!-- Second disclaimer bullets -->
                      <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:0;">
                        <tbody>
                          <tr>
                            <td width="100%" class="cell-base cell" style="padding:5px 0;">
                              <ul type="disc">
                                <li>The time taken for the fund transfer may be subject to regulatory or other requirements.</li>
                                <li>Please make sure your Bank Account has sufficient funds for the transfer amount plus applicable transfer fees. If ICICI Bank New York Branch has already processed a remittance transaction, you will be required to reimburse ICICI Bank New York Branch with the amount remitted and any other charges or costs incurred.</li>
                                <li>If you provide us with an incorrect account number or bank details of the recipient, you may lose the entire amount of the funds transferred.</li>
                                <li>To cancel your transaction, log in to Money2India USA portal, then go to &lsquo;My Transactions&rsquo; page, click on the 3 dots symbol on the right side of the transaction entry and click on &lsquo;Cancel Transaction&rsquo;.</li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                    </div>
                  </td>
                </tr>

                <tr><td style="font-family:'Mulish',sans-serif; font-size:16px;">&nbsp;</td></tr>
                <tr>
                  <td style="padding:0px 25px;" align="center">
                    <font style="font-size:14px; color:#000000; font-family:'Mulish',sans-serif;"><strong>Download the Money2India app:</strong></font>
                  </td>
                </tr>
                <tr>
                  <td style="padding-top:4px;">
                    <table width="300" border="0" cellpadding="0" cellspacing="0" align="center">
                      <tr>
                        <td width="150" align="left">
                          <a href="https://play.google.com/store/apps/details?id=com.icicibank.m2i" style="text-decoration:none; font-family:'Mulish',sans-serif; font-size:14px; color:#000000;">
                            <img src=${playstore} width="30" height="30" alt="Google-Play" style="display:inline-block; vertical-align:middle; margin-right:6px; border:0;">
                            <span style="vertical-align:middle;">Google Play</span>
                          </a>
                        </td>
                        <td width="10"></td>
                        <td width="150" align="left">
                          <a href="https://apps.apple.com/in/app/icici-bank-money2india/id1524595805" style="text-decoration:none; font-family:'Mulish',sans-serif; font-size:14px; color:#000000;">
                            <img src=${appstore} width="30" height="30" alt="App-Store" style="display:inline-block; vertical-align:middle; margin-right:6px; border:0;">
                            <span style="vertical-align:middle;">App Store</span>
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr><td style="font-size:16px;">&nbsp;</td></tr>
                <tr>
                  <td style="text-align:center; padding:0px 25px;" align="center">
                    <font style="font-size:16px; color:#000000; font-family:'Mulish',sans-serif;"><strong>For further assistance</strong></font><br>
                    <a href="https://money2india.icici.bank.in/usa/contact-us?cId=77" style="font-size:12px; color:#97291e; font-family:'Mulish',sans-serif; text-decoration:underline;" class="maroon"><font color="#97291E">Contact Us</font></a> ❘
                    <a href="mailto:money2india.icici.bank.in" style="font-size:12px; color:#97291e; font-family:'Mulish',sans-serif; text-decoration:underline;" class="maroon"><font color="#97291E">money2india.icici.bank.in</font></a> ❘
                    <a href="https://money2india.icici.bank.in/" style="font-size:12px; color:#97291e; font-family:'Mulish',sans-serif; text-decoration:underline;" class="maroon"><font color="#97291E">money2india.com</font></a>
                  </td>
                </tr>
                <tr><td style="font-size:16px;">&nbsp;</td></tr>
                <tr>
                  <td style="text-align:center; font-family:'Mulish',sans-serif; font-size:16px;">
                    Stay safe from fraudsters. Do not call any other number.<br>Do not write to any other email ID
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td align="center">
                    <table width="93%" border="0" cellpadding="0" cellspacing="0" align="center">
                      <tr>
                        <td style="text-align:center; padding:0px 25px;">
                          <font style="font-size:12px; color:#000000; font-family:'Mulish',sans-serif;">
                            ICICI Bank Limited, New York Branch, 575, 5<sup>th</sup> Avenue Suite 2600, New York, NY 10017<br>
                            +1-646-827-8450 (Monday – Friday, Time: 9:00 a.m. to 5:00 p.m)
                          </font>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr><td height="20"></td></tr>
                <tr><td height="12"></td></tr>
                <tr><td bgcolor="#E3530F" height="10"></td></tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
      <td></td>
    </tr>
    <tr>
      <td></td>
      <td style="max-width:100%; width:600px; padding:5px 0;">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tbody>
            <tr>
              <td style="padding:0px 25px; text-align:center;">
                <a href="https://www.icicibankusa.com/nri-banking/m2i-tnc?id=terms-and-conditions" style="font-size:13px; color:#97291e; font-family:'Mulish',sans-serif;" class="maroon"><font color="#97291E">T&amp;Cs</font></a> ❘
                <a href="https://www.icicibankusa.com/nri-banking/m2i-disclaimer?ITM=nli_termsOfUse_na_footer_3_CMS_regulatoryInformation_disclaimer_NLI" style="font-size:13px; color:#97291e; font-family:'Mulish',sans-serif;" class="maroon"><font color="#97291E">Disclaimer</font></a>
              </td>
            </tr>
            <tr><td>&nbsp;</td></tr>
          </tbody>
        </table>
      </td>
      <td></td>
    </tr>
  </table>
</body>
</html>
`;